export const PasswordRecoveryMutationKeys = {
  all: ["mutation", "password-recovery"] as const,
  sendPasswordRecoveryEmail: () => [...PasswordRecoveryMutationKeys.all, "send-password-recovery-email"] as const,
  resetPassword: () => [...PasswordRecoveryMutationKeys.all, "reset-password"] as const,
  createPassword: () => [...PasswordRecoveryMutationKeys.all, "create-password"] as const,
};
